/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_sales_features_order_list_Sort = {
    field: string;
    direction: co_getplato_grid_sales_features_order_list_Sort.direction;
};
export namespace co_getplato_grid_sales_features_order_list_Sort {
    export enum direction {
        ASC = 'ASC',
        DESC = 'DESC',
    }
}

